import React from 'react';
import { Language, SystemMessageData } from '@/types';
import { createConsistentUsernameFromUUID } from '@/lib/userUtils'; // Use the generator
import { Trash, User } from 'lucide-react';
import { useAppStore } from '@/hooks/useAppStore';
import { useTranslation } from '@/lib/translate';

interface UserStatusBubbleProps {
    data: SystemMessageData;
    preferredLanguage: Language; // To format timestamp
}

export const UserStatusBubble: React.FC<UserStatusBubbleProps> = ({
    data,
}) => {
    const {
        displayUsername,
        message,
        username,
        timestamp
    } = data;
    const user = useAppStore((state) => state.user);
    const isAdmin = !!useAppStore((state) => state.adminUser);
    const preferredLanguage = useAppStore((state) => state.preferredLanguage);
    const deleteMessage = useAppStore((state) => state.deleteMessage);
    const t = useTranslation(preferredLanguage);

    const isMe = !isAdmin && user?.userId == username;
    const prefix = isMe ? t("have") : t("has");
    return (
        <div className={`message-container flex flex-col items-center mb-4 animate-fadeIn`}>
            <div className={`flex flex-row gap-1 px-5 py-2 text-xs rounded-full bg-chotto-chat-notification shadow-xs items-center`}>
                <User size={12} />
                <span className="font-semibold text-secondary-foreground">
                    {displayUsername || createConsistentUsernameFromUUID(username)}
                    {isMe ? t(" (You)") : ""}
                </span>
                <span className="text-secondary-foreground">
                    {prefix} {message == "JOIN" ? t("joined the chat") : t("left the chat")}
                </span>
                {isAdmin && <button
                    onClick={() => {
                        if (window.confirm(t('Are you sure you want to delete this message?'))) {
                            deleteMessage(timestamp?.toString());
                        }
                    }}
                    title={t("Delete this message")}
                    className='p-1 text-red-700 rounded-full hover:bg-[#2a4d52] hover:text-white cursor-pointer'>
                    <Trash className='w-3.5 h-3.5' />
                </button>
                }
            </div>
        </div>
    );
};
